import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper";
import { ArrowForwardIos } from "@mui/icons-material";

const Coaches = () => {
    return (
        <>
            <Box sx={{ backgroundColor: '#F6F8F9' }}>
                <Grid container spacing={2}>
                    <Grid item md={5} xs={12}>
                        <Box sx={{ padding: '2.5rem 3rem' }}>
                            <Typography className="text2Mid" sx={{ color: '#3665D0' }}>300k+ Coches</Typography>
                            <Typography className="heading1bold" sx={{ marginTop: '1rem' }}>
                                We Answer Unemployment,
                                With Competent Employment
                            </Typography>
                            <Typography className="text1Mid">
                                The beginning is an idea, the destination is the dream, and the roadmap is the effort one puts in.
                                PPLACD is the catalyst on the journey by boosting and guiding the visionaries toward their ideal careers.
                            </Typography>
                            <Button variant="contained" sx={{ background: '#2544EE', borderRadius: '10px', mt:3 }}>
                                Connect with Coaches <ArrowForwardIos sx={{ fontSize: '12px' }} />
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item md={7} xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Swiper
                                effect={"coverflow"}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={"auto"}
                                coverflowEffect={{
                                    rotate: 50,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: true,
                                }}
                                pagination={true}
                                modules={[EffectCoverflow, Pagination]}
                                className="mySwiper"
                                initialSlide={1}
                            >
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-1.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-2.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-3.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-4.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-5.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-6.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-7.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-8.jpg" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width={'50%'} src="https://swiperjs.com/demos/images/nature-9.jpg" />
                                </SwiperSlide>
                            </Swiper>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default Coaches;